import createClient, { type Client } from "openapi-fetch";
import type { paths } from "../../../__definitions__/communication.changeengine.com-definitions";
import { serviceURL } from "../../../utils/service-url";

export const createShowroomClient = (customFetch?: typeof fetch): Client<paths> =>
  createClient<paths>({
    baseUrl: serviceURL("showroom"),
    headers: { "Content-Type": "application/json" },
    ...(customFetch ? { fetch: customFetch } : {}),
  });

export const showroomClient = createShowroomClient();
